import { render, staticRenderFns } from "./auction-work-imgs.vue?vue&type=template&id=77b11940&"
import script from "./auction-work-imgs.vue?vue&type=script&lang=js&"
export * from "./auction-work-imgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports